module.exports = __webpack_public_path__ + "static/img/business.3984742.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/business.png
// module id = d2uF
// module chunks = 20